<template>
  <div>
    <Breadcrumbs
      main-link="welcome"
      :main="$t('dashboardVue.dashboard')"
      :title="$t('myCabinetMenu.sorular')"
    />
    <!-- Container-fluid starts-->
    <div class="container">
      <div class="row">
        <div class="col-xl-8 ">
          <h3 class="mb-3">
            {{ $t('myCabinetMenu.mtrilriminSorular') }}
          </h3>

          <p>
            {{ $t('customerRequest.buBlmdSizTsdiqlnmiTdarksOlduunuzIrktlrinSorularnGr') }}
          </p>

          <div
            v-if="requests.length <1"
            class="alert alert-info"
          >
            {{ $t('customerRequest.heBirSoruYoxdur') }}
          </div>

          <div
            v-for="r in requests"
            :key="r.id"
          >
            <RequestItem
              :active-tab="'request'"
              :r="r"
            />
          </div>
        </div>
        <div class="col-xl-4" />
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import {getCustomerRequests} from "@/repositories/GeneralDataRepository";
import RequestItem from "@/components/parts/RequestItem.vue";

export default {
  components: {RequestItem},
  data() {
    return {
      mediaBase: mediaBase,
      requests: [],
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
    }),
  },
  watch: {
  },
  mounted() {
    this.getRequests();
  },
  methods: {

    getRequests(){
      getCustomerRequests(this.token).then(data => {
        if (data.code === 200) {
          this.requests = data.requests;
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          }).then(() => {
            window.location.reload();
          })
        }
      })
    }
  }
}
</script>
<style>
</style>
